
import React, { Component } from 'react'
import { Router, Route, Switch } from 'react-router'
import { HashRouter } from 'react-router-dom'
import Home from './pages/home/Home'
import Player from './pages/player/Player'
import Quotation from './pages/quotation/Quotation'
import Registration from './pages/registration/Registration'
import Pro from './pages/pro/'
import Summary from './pages/summary/Summary'

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'

import './App.css'

class App extends Component {

  constructor(props) {
    super(props)
    this.state = {
      device: { name: 'title' },
      app: {application: 'ponmusica'}
    }
  }

  render() {
    return (
      <HashRouter>
        <MuiThemeProvider>
          <Switch>
            <Route exact path="/" component={Player} app={this.state.app} />
            <Route path="/quotation" component={Quotation} app={this.state.app} />
            <Route path="/registration" component={Registration} app={this.state.app} />
            <Route path="/summary" component={Summary} app={this.state.app} />
            <Route path="/pro" component={Pro} app={this.state.app} />
            <Route path="/player/:playerId" component={Player} app={this.state.app} />
          </Switch>
        </MuiThemeProvider>
      </HashRouter>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js